{{params.Enum[this.params.value] ? params.Enum[this.params.value].replace('_', ' ') : ''}}


// WEBPACK FOOTER //
// ./src/app/shared/grid/renderer/enum-renderer.component.ts.EnumRendererComponent.html